import { Button, FlexBox } from '@dixa/lib-shared-habla';
import { useContext } from 'react';

import { CopilotDropdownActionContext } from 'components/copilotDropdown';

type CopilotDropdownFooterProps = {
  readonly handleInsertBelow: () => void;
  readonly disableInsertBelow: boolean;
  readonly handleReplace: () => void;
  readonly disableReplace: boolean;
  readonly hideImproveReply?: boolean;
  readonly disableImproveReply?: boolean;
  readonly draftContent?: string;
};
export const CopilotDropdownFooter = ({
  handleInsertBelow,
  disableInsertBelow,
  handleReplace,
  disableReplace,
  hideImproveReply,
  disableImproveReply = false,
  draftContent = '',
}: CopilotDropdownFooterProps): JSX.Element => {
  const { goToAction, featureFlags } = useContext(CopilotDropdownActionContext);
  return (
    <FlexBox padding="250">
      <FlexBox flex="1">
        {!hideImproveReply && featureFlags?.agentCopilotImproveWriting && (
          <Button
            variant="secondary"
            disabled={disableImproveReply}
            onClick={() => goToAction('improveReply', draftContent)}
          >
            Improve reply
          </Button>
        )}
      </FlexBox>
      <FlexBox flex="0" gap="200">
        <Button
          disabled={disableInsertBelow}
          variant="secondary"
          onClick={handleInsertBelow}
        >
          Insert below
        </Button>
        <Button
          disabled={disableReplace}
          variant="primary"
          onClick={handleReplace}
        >
          Replace
        </Button>
      </FlexBox>
    </FlexBox>
  );
};
